import { setAlert } from "./alert/alertSlice";
import { logOut } from "./auth/authSlice";

const payload = { title: 'Error', severity: 'error' };

export const formErrors = (res, setError = null) => dispatch => {
    switch (res?.status) {
        case 400:
            Object.keys(res?.data).forEach(function eachKey(key){
                return setError(key, { type: 'error', message: res?.data[key] })
            })
            break;
        
        case 401:
        case 403:
        case 404:
        case 500:
            return dispatch(setAlert({ msg: res?.data.msg, ...payload }));
        case 504:
            return dispatch(setAlert({ msg: res?.data?.error.message, ...payload }));
        default:
            return dispatch(setAlert({ msg: 'Algo anda mal chaval!', ...payload }))
    }
}

export const serverErrors = (error, action, setError = null) => dispatch => {
    dispatch(action());
    if(error.response){
        const status = error.response?.status;
        const data = error.response?.data;
        switch (status) {
            case 400:
                if(data.id){
                    return dispatch(setAlert({ msg: data.id, ...payload }))
                }else{
                    Object.keys(data).forEach(key => {
                        return setError(key, { type: 'error', message: data[key] })
                    })
                }
                break;
            
            case 401:
                dispatch(logOut());
                return dispatch(setAlert({ msg: data.msg, title: `Error ${status} `, severity: 'error' }));
                
            case 403:
            case 404:
            case 500:
                return dispatch(setAlert({ msg: data.msg, title: `Error ${status}`, severity: 'error' }))                

            default:
                return dispatch(setAlert({ msg: 'Parace que hubo un error, revisa tu consola para mas detalles.', title: 'Local Error', severity: 'error' }))
        }
    }else if(error.request){
        return dispatch(setAlert({ msg: 'Tiempo de espera agotado', title: 'Error 503', severity: 'error' }))
    }else{
        return dispatch(setAlert({ msg: 'Ops!, algo salio mal.', ...payload }))
    }
}